export default {
  status: 0,
  data: [
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '푸드',
      DIS_ITEM_CD: '00000135',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 35,
      DIS_ITEM_NM: '바나나 와플',
      DIS_ITEM_NM_KO: '바나나 와플',
      DIS_ITEM_NM_EN: 'Banana Waffles',
      DIS_ITEM_NM_JP: 'バナナワッフル',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000135',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/01.img_Bananawaffles.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4500,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '',
      ITEM_DESC_KO: '',
      ITEM_DESC_JP: '',
      ITEM_DESC_EN: '',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '푸드',
      DIS_ITEM_CD: '00000136',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 36,
      DIS_ITEM_NM: '브렉퍼스트 샌드위치',
      DIS_ITEM_NM_KO: '브렉퍼스트 샌드위치',
      DIS_ITEM_NM_EN: 'Breakfast Sandwich',
      DIS_ITEM_NM_JP: '朝食サンドイッチ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000136',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/02.img_Breakfastsandwich.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4200,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '',
      ITEM_DESC_KO: '',
      ITEM_DESC_JP: '',
      ITEM_DESC_EN: '',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '푸드',
      DIS_ITEM_CD: '00000137',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 37,
      DIS_ITEM_NM: '초콜렛 무스케이크',
      DIS_ITEM_NM_KO: '초콜렛 무스케이크',
      DIS_ITEM_NM_EN: 'Chocolate Mousse Cake',
      DIS_ITEM_NM_JP: 'チョコレートムースケーキ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000137',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/03.img_Chocolatemoussecake.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4500,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '',
      ITEM_DESC_KO: '',
      ITEM_DESC_JP: '',
      ITEM_DESC_EN: '',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '푸드',
      DIS_ITEM_CD: '00000138',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 38,
      DIS_ITEM_NM: '초코머핀',
      DIS_ITEM_NM_KO: '초코머핀',
      DIS_ITEM_NM_EN: 'Chocolate Muffin',
      DIS_ITEM_NM_JP: 'チョコレートマフィン',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000138',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/04.img_Chocolatemuffin.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 3200,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '',
      ITEM_DESC_KO: '',
      ITEM_DESC_JP: '',
      ITEM_DESC_EN: '',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '푸드',
      DIS_ITEM_CD: '00000139',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 39,
      DIS_ITEM_NM: '도너츠',
      DIS_ITEM_NM_KO: '도너츠',
      DIS_ITEM_NM_EN: 'Donut',
      DIS_ITEM_NM_JP: 'ドーナツ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000139',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/05.img_Donut.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 2400,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '',
      ITEM_DESC_KO: '',
      ITEM_DESC_JP: '',
      ITEM_DESC_EN: '',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
  ],
  message: '',
};
